import { BaseType } from '../base/base-type';
import { FundTypeId } from '../enum/shared/fund-type-id';

export class FundType extends BaseType {
  public colour!: string;
  // @ts-ignore
  public id: FundTypeId = 0;

  public isCash(): boolean {
    return this.id === 1;
  }

  public getChartDataColor(): string {
    return this.colour ?? '#E2ACE1';
  }
}
